var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contextNav",class:{contextNavVertical: _vm.vertical, bottomRight: _vm.fixed, alignRight: _vm.right}},_vm._l((_vm.buttons),function(button,id){return _c('contextNavBtn',{key:id,attrs:{"button":button},on:{"push":_vm.pushPass}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }